import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router';
import { Button, Col, ControlLabel, FormControl, Row } from 'react-bootstrap';
import { FormattedDate, FormattedTime } from 'react-intl';
import isObject from '../../../helpers/socratesLodash/isObject';
import { isBoolean } from 'lodash';
import cx from 'classnames';
import './InfoLabel.scss';

const getFormattedDisplayValue = (displayValue) => {
  if (
    Array.isArray(displayValue) &&
    displayValue.length > 0 &&
    !isObject(displayValue[0])
  ) {
    return displayValue.join(', ');
  }
  if (displayValue === null) {
    return '';
  }
  if (isBoolean(displayValue)) {
    return displayValue ? 'Yes' : 'No';
  }

  return displayValue;
};
const InfoLabel = ({
  labelSize,
  label,
  smFieldSize,
  date,
  dateTime,
  addonAfter,
  value,
  input,
  link,
  linkLabel,
  className,
  wrapperClass,
  infoButton,
  isLowerCase,
}) => {
  const displayValue = input ? input.value : value;

  // const formattedDisplayValue =
  //   Array.isArray(displayValue) && displayValue.length > 0 && !isObject(displayValue[0])
  //     ? startCase(displayValue.join(', '))
  //     : displayValue === null
  //     ? ''
  //     : displayValue;
  const formattedDisplayValue = getFormattedDisplayValue(displayValue);

  const displayInfo = addonAfter
    ? formattedDisplayValue + addonAfter
    : formattedDisplayValue;
  const menuSize = smFieldSize || (!label ? 12 : 12 - (labelSize || 2));

  const formControl = () => {
    return (
      <FormControl.Static
        className={cx(className, {
          'title-case': !isLowerCase,
        })}
      >
        {date && displayValue ? (
          <FormattedDate value={new Date(displayValue)} timeZone={'utc'} />
        ) : dateTime && displayValue ? (
          <span>
            <FormattedDate value={new Date(displayValue)} />
            &nbsp;
            <FormattedTime value={new Date(displayValue)} />
          </span>
        ) : (
          displayInfo
        )}
        {link && (
          <Link to={link} onlyActiveOnIndex>
            <Button bsStyle="default" bsSize="sm">
              {linkLabel}
            </Button>
          </Link>
        )}
      </FormControl.Static>
    );
  };

  if (label) {
    return (
      <Row
        className={
          wrapperClass ? 'info-label-wrapper ' + wrapperClass : 'info-label-wrapper'
        }
      >
        {label && (
          <Col sm={labelSize || 2}>
            <ControlLabel>
              {' '}
              {label} {infoButton}
            </ControlLabel>
          </Col>
        )}

        <Col sm={menuSize}>{formControl()}</Col>
      </Row>
    );
  } else {
    return formControl();
  }
};

InfoLabel.propTypes = {
  labelSize: PropTypes.number,
  label: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
  date: PropTypes.bool,
  value: PropTypes.node,
  link: PropTypes.string,
  linkLabel: PropTypes.string,
  input: PropTypes.object,
};

export default InfoLabel;
